import React from "react";
import { Box, Stack } from "@mui/material";
import { ProductStack } from "../../components/marketing/Products/ProductStack";
import { selectProductCardPropsByIds } from "../../components/marketing/Products/productCatalogAdapter";

const BEST_SELLER_PRODUCTS_IDS = [
    "tamale_green_salsa",
    "tamale_red_salsa",
    "tamale_street_corn",
    "rice_cup_street_corn",
    "rice_cup_mexican_homestyle",
    "rice_cup_peppers_chipotle"
];

export default function BestSellersSection() {
    const products = selectProductCardPropsByIds(BEST_SELLER_PRODUCTS_IDS);

    return (
        <Stack spacing={2} sx={{ width: "100%" }}>
            <Box
                sx={{
                    width: "100%",
                    px: { xs: 2, sm: 3, md: 2, lg: 2, xl: 1 },
                    mx: "auto",
                }}
            >
                <ProductStack products={products} />
            </Box>
        </Stack>
    );
}
